import { styled } from '@material-ui/core/styles'

export const heroStyles = ({ breakpoints }) => ({
  description: {
    [breakpoints.down('sm')]: {
      paddingTop: 40,
      paddingBottom: 64,
    },
    [breakpoints.between('md', 'lg')]: {
      paddingTop: 45,
      paddingBottom: 45,
      paddingLeft: 40,
      paddingRight: 40,
    },
    // From 1440 the text stops at 640px, the same width the shared hero uses at 1920+, while the card keeps filling
    // the column.
    [breakpoints.between(1440, 'lg')]: {
      paddingRight: 'calc(100% - 680px)',
    },
    [breakpoints.up('xl')]: {
      maxWidth: '640px',
    },
  },
  // From 1920 up the shared hero floats the card over the photo, which only works while the card is shorter than the
  // photo. The keepsake copy makes it taller, so the card stays in the flow here and the hero grows to fit it.
  wrapper: {
    [breakpoints.up('xl')]: {
      position: 'relative',
      top: 0,
      height: '100%',
      alignItems: 'center',
      transform: 'none',
    },
  },
})

export const Badge = styled('div')(({ theme: { breakpoints } }) => ({
  position: 'absolute',
  top: '9%',
  left: '15%',
  width: 168,
  zIndex: 1,
  [breakpoints.between(960, 1280)]: {
    width: 130,
  },
  [breakpoints.down('sm')]: {
    top: '4%',
    left: '4%',
    width: 113,
  },
}))
